import { NumberMakr } from "numbermakr";

export const createNumberMaker = () => new NumberMakr();
